module.exports = __webpack_public_path__ + "img/zeno-3.2e0b8d37.jpg";